import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MerchantPageShell from "../../components/merchant/MerchantPageShell";
import { loginVeyaTeam } from "../../lib/veyaTeamAuthApi";
import { useSession } from "../../hooks/useSession";

export default function VeyaTeamLogin() {
  const navigate = useNavigate();
  const { refreshSession } = useSession();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  function updateField(key, value) {
    setForm((prev) => ({ ...prev, [key]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();

    const email = form.email.trim();
    const password = form.password.trim();

    if (!email || !password) {
      setError("Email and password are required.");
      return;
    }

    setError("");
    setSubmitting(true);

    try {
      await loginVeyaTeam({ email, password });
      await refreshSession();

      navigate("/veya-team", { replace: true });
    } catch (err) {
      console.error("Veya Team login failed", err);
      setError(err?.message || "Could not log in");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <MerchantPageShell
      eyebrow="Veya Team"
      title="Internal login"
      lede="Access editorial tools and internal views."
    >
      <form className="merchant-form" onSubmit={handleSubmit}>
        <label className="merchant-field">
          <span className="merchant-label">Email</span>
          <input
            className="merchant-input"
            type="email"
            value={form.email}
            onChange={(e) => updateField("email", e.target.value)}
          />
        </label>

        <label className="merchant-field">
          <span className="merchant-label">Password</span>
          <input
            className="merchant-input"
            type="password"
            value={form.password}
            onChange={(e) => updateField("password", e.target.value)}
          />
        </label>

        {error ? <p className="merchant-error">{error}</p> : null}

        <div className="merchant-actions">
          <button className="gold-btn" type="submit" disabled={submitting}>
            {submitting ? "Signing in..." : "Sign in"}
          </button>
        </div>
      </form>
    </MerchantPageShell>
  );
}